/**
 * Redux selectors for application data
 */
import { createSelector } from '@reduxjs/toolkit';

export const selectSupplementalItems = state => state.application?.supplementalItems || {};
export const selectApplicationValues = state => state.application?.values || {};

/**
 * Selector that transforms supplementalItems object to sorted array of files
 * New schema: { questionId: { files: [...], documentReviewStatus: '', ... } }
 */
export const selectFilesArray = createSelector(
    selectSupplementalItems,
    supplementalItems => {
        if (supplementalItems && typeof supplementalItems === 'object' && !Array.isArray(supplementalItems)) {
            // Extract files from questionId entries
            return Object.entries(supplementalItems)
                .flatMap(([questionId, questionEntry]) => {
                    if (questionEntry?.files && Array.isArray(questionEntry.files)) {
                        return questionEntry.files.map(file => ({
                            ...file,
                            // Attach question-level metadata to each file
                            questionId,
                            documentReviewStatus: questionEntry.documentReviewStatus,
                            documentReviewUpdatedAt: questionEntry.documentReviewUpdatedAt,
                            documentReviewComments: questionEntry.documentReviewComments
                        }));
                    }
                    return [];
                })
                .sort((a, b) => {
                    // Sort by upload date, most recent first
                    const dateA = a.uploadedAt ? new Date(a.uploadedAt) : new Date(0);
                    const dateB = b.uploadedAt ? new Date(b.uploadedAt) : new Date(0);
                    return dateB - dateA;
                });
        }
        return [];
    }
);
